"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../assets/constants/constants");
const helpers_1 = require("../../utils/helpers");
const beds_1 = require("../../utils/beds");
const CheckinRequestBuilder = {
    putCheckinRequest: ({ bookId, propId, formValues, confirmValues, key, }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const tmpGuests = formValues.checkin[key].guests
            .filter(guest => guest.fullname)
            .map(guest => {
            return {
                name: (0, helpers_1.myTrim)(guest.fullname),
                docType: (0, helpers_1.myTrim)(guest.documentTypeGuest),
                doc: (0, helpers_1.myTrim)(guest.documentGuest),
                birthday: (0, moment_1.default)(guest.birthday, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL),
                email: (0, helpers_1.myTrim)(guest.email),
                ddi: (0, helpers_1.myTrim)(guest.ddi),
                phone: `${(0, helpers_1.myTrim)(guest.ddi)}${(0, helpers_1.myTrim)(guest.phone).replace(/\D/g, '')}`,
            };
        });
        let guest2 = formValues.checkin[key].guests.find(guest => guest.fullname);
        if (!guest2) {
            guest2 = {
                fullname: '',
                documentGuest: '',
                email: '',
                ddi: '',
                birthday: '',
                documentTypeGuest: '',
                phone: '',
            };
        }
        const guestDocs = formValues.checkin[key].guests
            .map(guest => Boolean(guest.fullname))
            .map((guest, index) => {
            if (guest) {
                return [
                    formValues.checkin[key].guests[index].fullname,
                    formValues.checkin[key].guests[index].documentGuest,
                    formValues.checkin[key].guests[index].email,
                ].join('|');
            }
            return '';
        });
        const country = (0, helpers_1.myTrim)(formValues.checkin[key].country);
        const parkingVehicle = `${((_a = formValues.checkin[key].vehicleBrand) === null || _a === void 0 ? void 0 : _a.trim()) || ''}-${((_b = formValues.checkin[key].vehicleColor) === null || _b === void 0 ? void 0 : _b.trim()) || ''}|${((_c = formValues.checkin[key].vehiclePlate) === null || _c === void 0 ? void 0 : _c.trim()) || ''}|${((_d = formValues.checkin[key].vehicleBrand) === null || _d === void 0 ? void 0 : _d.trim()) ? confirmValues.firstNight : ''}|${((_e = formValues.checkin[key].vehicleBrand) === null || _e === void 0 ? void 0 : _e.trim())
            ? (0, moment_1.default)(confirmValues.lastNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
            : ''}`;
        const [guests, ...visitors] = tmpGuests;
        const infoPreCheckIn = {
            name: (0, helpers_1.myTrim)(formValues.checkin[key].fullnameRequired),
            doc: (0, helpers_1.myTrim)(formValues.checkin[key].documentGuestRequired),
            docType: (0, helpers_1.myTrim)(formValues.checkin[key].documentTypeGuestRequired),
            birthday: (0, moment_1.default)(formValues.checkin[key].birthdayRequired, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL),
            ddi: (0, helpers_1.myTrim)(formValues.checkin[key].ddiRequired),
            phone: `${(0, helpers_1.myTrim)(formValues.checkin[key].ddiRequired)}${(0, helpers_1.myTrim)(formValues.checkin[key].phoneRequired)}`,
            email: (0, helpers_1.myTrim)(formValues.checkin[key].emailRequired),
            address: {
                zip: country === 'Brazil' ? formValues.checkin[key].addressCep : '',
                // os campos de endereço estão separados por \n no fim, então não tirem o ENTER dessa propriedade "fullAddress"
                fullAddress: `${country === 'Brazil' ? (0, helpers_1.myTrim)(formValues.checkin[key].addressName) : ''}
        ${country === 'Brazil' ? formValues.checkin[key].addressNumber : ''}
        ${country === 'Brazil' ? (0, helpers_1.myTrim)(formValues.checkin[key].addressComplement) : ''}
        ${country === 'Brazil' ? (0, helpers_1.myTrim)(formValues.checkin[key].addressDistrict) : ''}`,
                state: country === 'Brazil' ? formValues.checkin[key].addressState : '',
                city: country === 'Brazil' ? (0, helpers_1.myTrim)(formValues.checkin[key].addressCity) : '',
                country,
            },
            guests: guests ? [guests] : [],
            visitors,
            hostingWork: formValues.checkin[key].hostingWork,
            hostingPurchases: formValues.checkin[key].hostingPurchases,
            hostingPrivacy: formValues.checkin[key].hostingPrivacy,
            hostingTourism: formValues.checkin[key].hostingTourism,
            vehicles: [
                {
                    model: `${((_f = formValues.checkin[key].vehicleBrand) === null || _f === void 0 ? void 0 : _f.trim()) || ''} ${((_g = formValues.checkin[key].vehicleColor) === null || _g === void 0 ? void 0 : _g.trim()) || ''}`,
                    plate: `${((_h = formValues.checkin[key].vehiclePlate) === null || _h === void 0 ? void 0 : _h.trim()) || ''}`,
                    usedFrom: `${((_j = formValues.checkin[key].vehicleBrand) === null || _j === void 0 ? void 0 : _j.trim())
                        ? (0, moment_1.default)(confirmValues.firstNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
                        : ''}`,
                    usedTo: `${((_k = formValues.checkin[key].vehicleBrand) === null || _k === void 0 ? void 0 : _k.trim())
                        ? (0, moment_1.default)(confirmValues.lastNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
                        : ''}`,
                },
            ],
        };
        const [firstName, lastName, lastsNames] = (0, helpers_1.splitFullName)(formValues.checkin[key].fullnameRequired);
        const response = {
            hostingTourism: formValues.checkin[key].hostingTourism,
            hostingPrivacy: formValues.checkin[key].hostingPrivacy,
            hostingPurchases: formValues.checkin[key].hostingPurchases,
            hostingWork: formValues.checkin[key].hostingWork,
            propertyId: propId,
            bookId: +bookId,
            infoPreCheckIn: JSON.stringify(infoPreCheckIn),
            infoPreCheckInBeds: (0, beds_1.formatInfoPreCheckInBeds)(JSON.stringify(infoPreCheckIn)),
            parkingVehicle,
            guest2Doc: `Check-in: ${(0, helpers_1.myTrim)(formValues.checkin[key].checkInTime)} | Check-out: ${(0, helpers_1.myTrim)(formValues.checkin[key].checkOutTime)}`,
            guestFirstName: (0, helpers_1.myTrim)(firstName),
            guestName: `${(0, helpers_1.myTrim)(lastName)} ${(0, helpers_1.myTrim)(lastsNames)}`,
            guestPhone: `${(0, helpers_1.myTrim)(formValues.checkin[key].ddiRequired)}${(0, helpers_1.myTrim)(formValues.checkin[key].phoneRequired.replace(/\D/g, ''))}`,
            guestAddress: country === 'Brazil'
                ? `${formValues.checkin[key].addressName}, ${formValues.checkin[key].addressNumber}, ${(0, helpers_1.myTrim)(formValues.checkin[key].addressComplement)}, ${(0, helpers_1.myTrim)(formValues.checkin[key].addressDistrict)}, ${formValues.checkin[key].addressCep}`
                : '',
            guestCity: country === 'Brazil' ? (0, helpers_1.myTrim)(formValues.checkin[key].addressCity) : '',
            guestState: country === 'Brazil' ? (0, helpers_1.myTrim)(formValues.checkin[key].addressState) : '',
            guestCountry: country,
            guestDoc: (0, helpers_1.myTrim)(formValues.checkin[key].documentGuestRequired),
            guestBirthDate: (0, moment_1.default)(formValues.checkin[key].birthdayRequired, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_PT_BR),
            guest2Name: guestDocs.filter(guest => guest).join('; '),
            guest2Annotations: '',
        };
        return response;
    },
    hubspotFormBuilder: ({ formValues, key, pageUri, pageName, reservedata, propInfo, }) => {
        var _a;
        let guest2 = formValues.checkin[key].guests.find(guest => guest.fullname);
        if (!guest2) {
            guest2 = {
                fullname: '',
                documentGuest: '',
                email: '',
                ddi: '',
                birthday: '',
                documentTypeGuest: '',
                phone: '',
            };
        }
        const splitedFullName = (0, helpers_1.myTrim)(formValues.checkin[key].fullnameRequired).split(' ');
        const firstName = splitedFullName.splice(0, 1)[0];
        const lastname = splitedFullName.join(' ');
        const bookingReason = ['hostingPrivacy', 'hostingTourism', 'hostingPurchases', 'hostingWork'].filter(reason => formValues.checkin[key][reason])[0] || '';
        const reasonsHash = {
            hostingPrivacy: 'Namorar',
            hostingWork: 'Trabalhar',
            hostingPurchases: 'Comprar',
            hostingTourism: 'Turistar',
        };
        const firstDate = (0, moment_1.default)(reservedata.firstNight);
        const lastDate = (0, moment_1.default)((0, moment_1.default)(reservedata.lastNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL));
        const address = `${(0, helpers_1.myTrim)(formValues.checkin[key].addressName)} ${formValues.checkin[key].addressNumber}
    ${(0, helpers_1.myTrim)(formValues.checkin[key].addressComplement)}`;
        const guestList = ['segundo', 'terceiro', 'quarto', 'quinto'];
        const guestHubs = guestList.map((position, idx) => {
            var _a;
            const guest = formValues.checkin[key].guests[idx];
            return [
                {
                    name: `nome_${position}_hospede`,
                    value: (0, helpers_1.myTrim)((guest === null || guest === void 0 ? void 0 : guest.fullname) || ''),
                },
                {
                    name: `documento_${position}_hospede`,
                    value: (0, helpers_1.myTrim)((guest === null || guest === void 0 ? void 0 : guest.documentGuest) || ''),
                },
                {
                    name: `data_de_nascimento_${position}${idx > 0 ? '_hospede' : ''}`,
                    value: (guest === null || guest === void 0 ? void 0 : guest.birthday)
                        ? (0, moment_1.default)(guest === null || guest === void 0 ? void 0 : guest.birthday, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL)
                        : ' ',
                },
                {
                    name: `e_mail_${position}_hospede`,
                    value: (0, helpers_1.myTrim)((guest === null || guest === void 0 ? void 0 : guest.email) || ''),
                },
                {
                    name: `celular_${position}_hospede`,
                    value: `${(guest === null || guest === void 0 ? void 0 : guest.phone) ? `${guest === null || guest === void 0 ? void 0 : guest.ddi}${(_a = guest === null || guest === void 0 ? void 0 : guest.phone) === null || _a === void 0 ? void 0 : _a.replace(/\D/g, '')}` : ' '}`,
                },
            ];
        });
        const infoHubspot = {
            fields: [
                { name: 'email', value: (0, helpers_1.myTrim)(formValues.checkin[key].emailRequired) },
                { name: 'firstname', value: firstName },
                { name: 'lastname', value: lastname },
                { name: 'documento', value: (0, helpers_1.myTrim)(formValues.checkin[key].documentGuestRequired) },
                {
                    name: 'address',
                    value: (0, helpers_1.myTrim)(address.replace(/\n/, '')),
                },
                { name: 'country', value: (0, helpers_1.myTrim)(formValues.checkin[key].country) },
                { name: 'city', value: (0, helpers_1.myTrim)(formValues.checkin[key].addressCity || '') },
                { name: 'state', value: formValues.checkin[key].addressState || '' },
                { name: 'zip', value: formValues.checkin[key].addressCep || '' },
                {
                    name: 'mobilephone',
                    value: `${(0, helpers_1.myTrim)(formValues.checkin[key].ddiRequired)}${(0, helpers_1.myTrim)((_a = formValues.checkin[key].phoneRequired) === null || _a === void 0 ? void 0 : _a.replace(/\D/g, ''))}`,
                },
                {
                    name: 'data_de_nascimento',
                    value: (0, moment_1.default)(formValues.checkin[key].birthdayRequired, constants_1.DEFAULT_FORMAT_DATE_PT_BR).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL),
                },
                { name: 'quantidade_de_hospedes', value: +reservedata.guestsQtyString },
                { name: 'noites_vendidas', value: lastDate.diff(firstDate, 'days') },
                { name: 'valor_da_venda', value: reservedata.totalPrice },
                { name: 'categoria', value: reservedata.suite.suiteTitle },
                { name: 'propriedade', value: propInfo.name },
                { name: 'codigo_da_reserva', value: parseInt(reservedata.checkinData, 10) },
                { name: 'canal_de_origem', value: reservedata.refererEditable },
                { name: 'check_in', value: reservedata.firstNight },
                { name: 'check_out', value: (0, moment_1.default)(reservedata.lastNight).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL) },
                { name: 'consentimento_e_mail', value: formValues.acceptOffers ? 'Sim' : 'Não' },
                { name: 'interesse', value: reasonsHash[bookingReason] },
                { name: 'data_da_reserva', value: (0, moment_1.default)(new Date()).format(constants_1.DEFAULT_FORMAT_DATE_INTERNATIONAL) },
            ],
            context: {
                pageName,
                pageUri,
                hutk: '',
            },
        };
        infoHubspot.fields = [...infoHubspot.fields, ...guestHubs.flatMap(el => el)];
        return infoHubspot;
    },
};
exports.default = CheckinRequestBuilder;
